import { CONSTANTS } from '../data.js';

export const getEncyclopediaUnlockCost = (dragonName) => {
  const dragon = CONSTANTS.DRAGONS[dragonName];
  if (!dragon) {
    // This case should ideally not be hit if the UI is driven by CONSTANTS.DRAGONS
    // But it's good practice to handle it.
    console.error(`Dragon not found in CONSTANTS: ${dragonName}`);
    return 999999999; // Return a high cost for non-existent dragons
  }
  return CONSTANTS.ENCYCLOPEDIA_UNLOCK_COSTS[dragon.rarity] || 1000;
};

export const checkForNewUnlocks = (unlockedDragons) => {
  // This function is now a stub since Divine and Transcendental dragons, 
  // which had special unlock conditions, are removed.
  // It can be used later if other special unlock conditions are added.
  return [];
};
